import { DigitalGpSubmission, Variants } from '@sky-distribution/digital-gp-submission';
import {
  CoverageMetaList,
  CoveragesDetails,
  DigitalCoverages, SubmissionOptions,
} from '@sky-distribution/gp-onboarding-generic-submission';
import { RateData, Submission, SubmissionIds } from '@sky-distribution/gp-onboarding-policy-service';
import {
  AppStateMachineConfig, AppStateMachineContext, AppStateMachineEvent, AppStateMachineServiceMap,
} from '../types';

const DEFAULT_TENANT = 'beesafe';
const DEFAULT_LANGUAGE = 'pl';

export function getDefaultMachineConfig(id: string, context: Partial<AppStateMachineContext>): AppStateMachineConfig {
  return {
    id,
    context: {
      route: '',
      productCode: '',
      tenant: DEFAULT_TENANT,
      language: DEFAULT_LANGUAGE,
      salesPortalButtonEnabled: false,
      digitalCoverages: {} as DigitalCoverages,
      submission: {} as Submission,
      digitalSubmission: {} as DigitalGpSubmission,
      rateData: {} as RateData,
      ids: {} as SubmissionIds,
      digitalTrackingCodes: {},
      coveragesMeta: {} as CoverageMetaList,
      submissionOptions: {} as SubmissionOptions,
      coveragesDetails: {} as CoveragesDetails,
      billingPeriods: [],
      consents: {},
      consentDictionary: [],
      digitalOffers: [] as Variants,
      ...context,
    },
    type: 'parallel',
    schema: {
      context: {} as AppStateMachineContext,
      events: {} as AppStateMachineEvent,
      services: {} as AppStateMachineServiceMap,
    },
    on: {
      ERROR: {
        target: '#error.generic',
      },
      NOT_FOUND: {
        target: '#error.notFound',
      },
      CHANGE_ROUTE: {
        actions: 'changeRoute',
      },
    },
    predictableActionArguments: true,
    preserveActionOrder: true,
  };
}
